import { OsaNodeCoding } from "../../coding/models/OsaNodeCoding";
import { Score } from "@keita/lanepatrol-sdk";
import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { CreateOsaNode, OsaNode } from "../models/OsaNode";
import { OptionalScope } from "../../shared/models/OptionalScope";

const prefix = "/osa-nodes";

export const OsaNodeApi = {
  create: async (request: CreateOsaNode) => {
    return await jwtAuthAxios().post<OsaNode[]>(prefix, request);
  },

  delete: async (deletedNodeId: string) => {
    return await jwtAuthAxios().delete(`${prefix}/${deletedNodeId}`);
  },

  getScore: async (nodeId: string) => {
    return await jwtAuthAxios().get<Score | null>(`${prefix}/${nodeId}/score`);
  },

  get: async (nodeId: string, scopes: OptionalScope[] = []) => {
    return await jwtAuthAxios().get<OsaNode>(`${prefix}/${nodeId}`, {
      params: {
        scopes: scopes.join(),
      },
    });
  },

  listCodingEntries: async (nodeId: string) => {
    return await jwtAuthAxios().get<OsaNodeCoding>(
      `${prefix}/${nodeId}/coding`
    );
  },
};
